// src/store/compressSlice.js
import { createSlice } from "@reduxjs/toolkit";

const ContactsUpdationSlice = createSlice({
  name: "contactsUpdation",
  initialState: {
    isContactUpdated: false,
  },
  reducers: {
    setContactUpdated: (state, action) => {
      state.isContactUpdated = action.payload;
    },
  },
});

export const { setContactUpdated } = ContactsUpdationSlice.actions;

export default ContactsUpdationSlice.reducer;
